import { router, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import type { PageProps } from "@/types/inertia"

// Top-of-page banner shown whenever the current session is impersonating
// another user (`props.impersonation.active === true` from inertia_share).
// Rendered inside AdminShell, AccountShell, and AppShell. Clicking Stop
// hits the admin stop_impersonating route which swaps the session back.
export function ImpersonationBanner() {
  const { props } = usePage<PageProps>()
  const state = props.impersonation
  if (!state?.active) return null

  const stop = () => router.delete(stopUrl())

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex items-center justify-center gap-4 bg-signal px-4 py-3 text-ink-display"
    >
      <span>
        Impersonating <strong>{state.impersonated_name}</strong>
        {state.true_admin_name && (
          <>
            {" "}
            as <strong>{state.true_admin_name}</strong>
          </>
        )}
      </span>
      <Button type="button" variant="dark" size="sm" onClick={stop}>
        Stop
      </Button>
    </div>
  )
}

// Best-effort URL — we don't know the impersonated user's id client-side,
// so we post to /admin/users/0/stop_impersonating which the server routes
// to stop_impersonating_user regardless of the id.
function stopUrl() {
  return "/admin/users/0/stop_impersonating"
}
